const ABOUT_IMG =
  "https://images.unsplash.com/photo-1611094016919-36b65678f3d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBsaXZpbmclMjByb29tJTIwaW50ZXJpb3IlMjBicmlnaHR8ZW58MHx8fHwxNzgzMzcxMzcxfDA&ixlib=rb-4.1.0&q=85";
const ABOUT_IMG_2 =
  "https://images.pexels.com/photos/6466236/pexels-photo-6466236.jpeg";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-cream py-24 md:py-32 lg:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-6 lg:sticky lg:top-32">
            <div className="text-xs tracking-[0.3em] uppercase text-brass mb-6">
              Why AKT Global
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-espresso font-light">
              Hospitality as it
              <br />
              <em className="not-italic text-brass">was meant to be.</em>
            </h2>
            <p className="mt-8 text-espresso/75 text-base lg:text-lg leading-relaxed max-w-lg">
              AKT Global Enterprises LLC is a boutique management firm devoted to
              elevating short-term rentals. Every property we steward is treated
              like our own — with a deliberate blend of design sensibility,
              operational rigor, and warm, human hospitality.
            </p>
            <p className="mt-4 text-espresso/70 text-base leading-relaxed max-w-lg">
              From dynamic pricing to spotless turnovers, we handle the entire
              guest journey while you enjoy transparent reporting and
              predictable, elevated returns.
            </p>

            <div className="mt-10 grid grid-cols-2 gap-6 max-w-md">
              {[
                ["Full-service", "End-to-end management"],
                ["Data-driven", "Revenue optimization"],
                ["Vetted guests", "Trust & safety first"],
                ["Local presence", "On-the-ground team"],
              ].map(([t, s]) => (
                <div key={t} className="border-t border-espresso/15 pt-4">
                  <div className="font-serif text-xl text-espresso">{t}</div>
                  <div className="text-xs uppercase tracking-[0.15em] text-taupe mt-1">{s}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-6 relative">
            <div className="grid grid-cols-6 gap-4">
              <div className="col-span-5 aspect-[4/5] overflow-hidden">
                <img src={ABOUT_IMG} alt="Interior detail" className="h-full w-full object-cover" />
              </div>
              <div className="col-span-6 -mt-20 ml-auto w-3/4 aspect-[3/2] overflow-hidden">
                <img src={ABOUT_IMG_2} alt="Bedroom" className="h-full w-full object-cover" />
              </div>
              <div className="col-span-6 mt-4 flex items-end justify-end">
                <div className="max-w-xs text-right">
                  <div className="font-serif text-3xl text-espresso">&ldquo;Detail is not detail. It makes the design.&rdquo;</div>
                  <div className="text-[10px] tracking-[0.2em] uppercase text-taupe mt-3">— Charles Eames</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
